import React, { useEffect, useState, useRef } from "react";
import DataTablePaginationServer from "../../../Components/DataTable/DataTablePaginationServer";
import { ButtonAdd, ButtonEdit, ButtonDelete } from "../../../Components/Button/Button";
import AddDailyJobDetailsRecordNotSuccess from "./AddDailyJobDetailsRecordNotSuccess";
import Loading from "../../../Components/Loading/Loading";
import { useRecoilValue, useRecoilState } from "recoil";
import { userData } from "../../../DataContext/DataContext";
import {
  AlertError,
  AlertSuccess,
  AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import axios from "axios";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import Card from "@mui/material/Card";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import DateRange from "../../../Components/DateRange/DateRange";
import { TextInput } from "../../../Components/Input/Input";
import moment from "moment/moment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ButtonOther } from "../../../Components/Button/Button";
import ImgExcell from "../../../Assets/Images/excel.png";
import * as SiIcons from "react-icons/si";
import { CSVLink, CSVDownload } from "react-csv";
import { DialogTitle } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Btn from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import CancelIcon from "@mui/icons-material/Cancel";
import ExportExcel from "../../../Components/ExportExcel/ExportExcel";
import { AlertConfirm } from "../../../Components/AlertDialog/AlertDialog";
import ExcelExportHelperNotSuccess from "../../../Components/ExportExcel/ExcelExportHelperNotSuccess";
import Tooltip from "@mui/material/Tooltip";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { useReactToPrint } from "react-to-print";

function DailyJobDetailsRecordNotSuccess(props) {
  const [openDialogformEdit, setOpenDialogFormEdit] = useState(false);
  const [openDialogformAdd, setOpenDialogFormAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const user = useRecoilValue(userData);
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [documentData, setDocumentData] = useState([]);
  const [documentId, setDocumentId] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [countRowData, setCountRowData] = useState(0);
  const [documentDataToprint, setDocumentDataToprint] = useState([]);
  const tableRef = useRef();
  const componentRef = useRef();

  const getData = async (page, pageSize, startDate, endDate, search) => {
    const url =
      UrlApi +
      `get_document_data?page=${page}
                          &page_size=${pageSize}
                          &start_date=${moment(startDate).format("YYYY-MM-DD")}
                          &end_date=${moment(endDate).format("YYYY-MM-DD")}
                          &search=${search}&status_id=${2}`;
    await axios
      .get(url, authorization)
      .then((res) => {
        if (res.data.length > 0) {
          setCountRowData(res.data[0].count_row_data);
        }
        setDocumentData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });

    setLoading(true);
    await axios
      .get(UrlApi + "get_email_data_for_send_data", authorization)
      .then((res) => {
        let newData = [];
        res.data.map((item) => {
          newData.push(item.master_email_send_file);
        });
        setEmail(newData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };

  const sendData = async () => {
    const data = {
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      empId: user.user_id,
      email: email
    };
    const url = UrlApi + `send_data`;
    setLoading(true);
    await axios
      .post(url, data, authorization)
      .then((res) => {
        if (res.data.status === 1) {
          AlertSuccess(res.data.message);
          setLoading(false);
        } else {
          AlertWarning(res.data.message);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };

  const exportExcells = async () => {
    const workSheetColumnsName = columnsExport.map((item) => {
      return [
        item.title
      ];
    });
    setLoading(true);
    await axios
      .get(
        UrlApi +
        `get_document_data_export?page=${page}
          &page_size=${pageSize}
          &start_date=${moment(startDate).format("YYYY-MM-DD")}
          &end_date=${moment(endDate).format("YYYY-MM-DD")}
          &search=${search}&status_id=${2}`,
        authorization
      )
      .then((res) => {
        if (res.data.length > 0) {
          const textStartDate = moment(startDate).format("DD/MM/YYYY");
          const textEndDate = moment(endDate).format("DD/MM/YYYY");
          let dateText = moment(startDate).format("DD/MM/YYYY");
          if (textStartDate !== textEndDate) {
            dateText += ` ถึง ${moment(endDate).format("DD/MM/YYYY")}`;
          }
          ExcelExportHelperNotSuccess(res.data, dateText);
          setLoading(false);
        } else {
          setLoading(false);
          AlertWarning("ไม่พบข้อมูลที่ต้องการส่งออก");
        }
      })
      .catch((err) => {
        AlertError(err);
      });
  };

  const deleteDocument = async (documentId) => {
    setLoading(true);
    setLoadData(false);
    await axios
      .post(UrlApi + "delete_document", { document_id: documentId }, authorization)
      .then((res) => {
        AlertSuccess(res.data.message, () => { }, 2000);
        setLoadData(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  }

  useEffect(() => {
    document.addEventListener("keydown", detextKeyDown, true);
    getData(page, pageSize, startDate, endDate, search);
  }, [openDialogformEdit === false, openDialogformAdd === false, loadData]);

  const detextKeyDown = (e) => {
    if (e.key === "F9") {
      setOpenDialogFormAdd(true);
      return false;
    }
  };

  const columns = [
    {
      title: "ลบ",
      field: "docuno_hd_id",
      filtering: false,
      export: false,
      headerStyle: {
        width: 1,
        maxWidth: 1,
      },
      cellStyle: { width: 1, maxWidth: 1 },
      render: (rowData) => (
        <ButtonDelete
          onClick={() => {
            AlertConfirm('ยืนยันการลบข้อมูลเอกสาร' + ' : ' + rowData.customer_name, () => {
              deleteDocument(rowData.docuno_hd_id);
            });
          }}
        />
      ),
    },
    {
      title: "เปิด",
      field: "docuno_hd_id",
      filtering: false,
      export: false,
      headerStyle: {
        width: 1,
        maxWidth: 1,
      },
      cellStyle: { width: 1, maxWidth: 1 },
      render: (rowData) => (
        <ButtonEdit
          onClick={() => {
            setDocumentId(rowData.docuno_hd_id);
            setOpenDialogFormEdit(true);
          }}
        />
      ),
    },
    {
      title: "ลำดับ",
      field: "list_no",
      filtering: false,
      headerStyle: {
        width: "10px",
        maxWidth: "10px",
      },
      cellStyle: { width: "5px", maxWidth: "5px" },
    },
    {
      title: "ว/ด/ป ที่นัดลูกค้า",
      field: "docudate",
      headerStyle: {
        width: "8rem",
        maxWidth: "8rem",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "Code Sup",
      field: "sup_code",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
      },
      cellStyle: { width: "10%", maxWidth: "10%" },
    },
    {
      title: "Code Sales",
      field: "emp_code",
      headerStyle: {
        width: "5rem",
        maxWidth: "5rem",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "Name Sales",
      field: "sale_name",
      height: 10,
      headerStyle: {
        width: "5%",
        maxWidth: "5%",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "ประเภทใบสมัคร",
      field: "job_type_name",
      height: 10,
      headerStyle: {
        width: "5%",
        maxWidth: "5%",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "No.ใบสั่ง",
      field: "listno_order",
      headerStyle: {
        width: "10px",
        maxWidth: "10px",
      },
      cellStyle: { width: "10px", maxWidth: "10px" },
    },
    {
      title: "ชื่อ-สกุลลูกค้า",
      field: "customer_name",
      // render: (rowData) => {
      //   return MaskCharacter(rowData.customer_name);
      // },
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
      },
      cellStyle: { width: "10%", maxWidth: "10%" },
    },
    // {
    //   title: "Security Code",
    //   field: "security_code",
    //   headerStyle: {
    //     width: "20%",
    //     maxWidth: "20%",
    //   },
    //   cellStyle: { width: "20%", maxWidth: "20%" },
    // },
    {
      title: "พื้นที่ ที่สั่งงาน(เขต)",
      field: "order_area_name",
      headerStyle: {
        width: "10rem",
        maxWidth: "10rem",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "Zone",
      field: "zone_master_name",
      headerStyle: {
        width: "5rem",
        maxWidth: "5rem",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "ว/ด/ป ที่ส่งงาน",
      field: "delivery_date",
      headerStyle: {
        width: "8rem",
        maxWidth: "8rem",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "หมายเหตุ",
      field: "remark",
      headerStyle: {
        width: "5rem",
        maxWidth: "5rem",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    // {
    //   title: "ว/ด/ป ที่ส่งงาน",
    //   field: "delivery_date",
    //   headerStyle: {
    //     width: "8rem",
    //     maxWidth: "8rem",
    //   },
    //   cellStyle: { width: "5%", maxWidth: "5%" },
    // },
    {
      title: "ผลการวิ่งงาน",
      field: "status_document_master_name",
    },
  ];

  const columnsExport = [
    {
      title: "ลำดับ",
    },
    {
      title: "ว/ด/ป ที่นัดลูกค้า",
    },
    {
      title: "Code Sup",
    },
    {
      title: "Code Sales",
    },
    {
      title: "Name Sales",
    },
    {
      title: "ประเภทใบสมัคร",
    },
    {
      title: "No.ใบสั่ง",
    },
    {
      title: "ชื่อ-สกุลลูกค้า",
    },
    // {
    //   title: "Security Code",
    // },
    {
      title: "พื้นที่ ที่สั่งงาน(เขต)",
    },
    {
      title: "Zone (A,B)",
    },
    {
      title: "หมายเหตุ",
    },
    // {
    //   title: "วันที่ส่งงาน",
    // },
    // {
    //   title: "เดือนที่เก็บสำเร็จ",
    // },
    // {
    //   title: "ปีที่เก็บสำเร็จ",
    // },
    {
      title: "ผลการวิ่งงาน",
    },
  ];

  const textStartDate = moment(startDate).format("DD/MM/YYYY");
  const textEndDate = moment(endDate).format("DD/MM/YYYY");
  let dateText = moment(startDate).format("DD/MM/YYYY");
  if (textStartDate !== textEndDate) {
    dateText += ` ถึง ${moment(endDate).format("DD/MM/YYYY")}`;
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    fonts:[{weight: 'bold'}],
    // onBeforePrint: async () => await getDocumentDataToprint(),
    // onAfterPrint: ()=> setDocumentDataToprint([]),
    onBeforeGetContent: async () => {
      await getDocumentDataToprint()
    }
  });

  const getDocumentDataToprint = async () => {
    setLoading(true);
    await axios
      .get(
        UrlApi +
        `get_document_data_to_print?page=${page}
          &page_size=${pageSize}
          &start_date=${moment(startDate).format("YYYY-MM-DD")}
          &end_date=${moment(endDate).format("YYYY-MM-DD")}
          &search=${search}&status_id=${2}`,
        authorization
      )
      .then((res) => {
        if (res.data.length > 0) {
          setDocumentDataToprint(res.data);
          tableExport();
          setLoading(false);
        }
      })
      .catch((err) => {
        AlertError(err);
      });
  };

  const HeaderPage = () => {
    return (
      <>
        <div style={{ paddingTop: "10px" }}>
          <label
            style={{ marginLeft: "10px", marginTop: "10px", fontSize: "18px" }}
          >
            บันทึกงานไม่สำเร็จประจำวัน
          </label>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              {datePicker()}
              <div style={{ marginLeft: '38px' }}>
                <ButtonAdd
                  label="เพิ่ม"
                  variant="contained"
                  onClick={() => {
                    setOpenDialogFormAdd(true);
                  }}
                />
              </div>
              <ButtonOther
                onClick={() => {
                  getData(page, pageSize, startDate, endDate, search);
                }}
                message="โหลดข้อมูลใหม่"
                width="20ch"
                startIcon={<RefreshIcon />}
                background="#61C495"
              />
              <ButtonOther
                  onClick={ async () => {
                    await getDocumentDataToprint();
                    handlePrint();
                  }}
                  message="พิมพ์"
                  width="20ch"
                  startIcon={<LocalPrintshopIcon />}
                  background="#FFCC99"
                />
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <div style={{ marginRight: "12px", marginTop: "2px" }}>
              <Tooltip title="ค้นหา ชื่อลูกค้า, Security Code, ชื่อทีม">
                <TextInput
                  width="100%"
                  placeholder="ค้นหา ชื่อลูกค้า, Security Code"
                  onKeyDown={(e) => { }}
                  value={search}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      setPage(0);
                    }
                    setSearch(e.target.value);
                    getData(page, pageSize, startDate, endDate, e.target.value);
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setSearch("");
                          setPage(0);
                          getData(0, pageSize, startDate, endDate, "");
                        }}
                        edge="end"
                      >
                        <CancelIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
                </Tooltip>
              </div>
              {/* {
                <ButtonOther
                  onClick={() => {
                    sendData();
                  }}
                  message="ส่งข้อมูล"
                  width="15ch"
                  startIcon={<SendIcon />}
                  background="#92CEA8"
                  
                  
                />
              } */}
              {
                <ButtonOther
                  onClick={() => {
                    exportExcells();
                  }}
                  message="ส่งออก"
                  width="15ch"
                  startIcon={<SiIcons.SiMicrosoftexcel />}

                />
              }
            </div>
          </div>
        </div>
      </>
    );
  };

  const tableExport = () =>{
    return (
      <>
        <div style={{display: 'none'}}>
          <div ref={componentRef}>
            {documentDataToprint.map((item)=>{
              return item.document_data.length > 0 ? <div className="box-print">
              <div style={{width: '40%', display: 'flex', justifyContent: 'space-between', fontSize: 16 , fontWeight: 'bold'}}>
                  <label>รายงานการวิ่งงานประจำวันของธนาคาร UOB</label>
                  <label>DGF Express</label>
              </div>
              <div style={{width: '45%', display: 'flex', justifyContent: 'space-between', fontSize: '14px', fontWeight: 'bold'}}>
                  <label>รายงานประจำวันที่ {dateText}</label>
                  <label style={{border: '1px solid black', width: '10rem', paddingLeft: '3px'}}>สถานะ : งานไม่สำเร็จ</label>
              </div>
              <div style={{width: '30%', display: 'flex', justifyContent: 'space-between', marginBottom: '15px', fontSize: '14px', fontWeight: 'bold'}}>
                  <label>จำนวนงานที่ไม่สำเร็จ {item.document_data.length} งาน</label>
                  <label style={{textDecorationLine: 'underline', textDecorationStyle: 'double'}}>ทีม : {item.sup_code}</label>
              </div>
              <table id="table-print" style={{width: '100%'}}>
                  <thead>
                      <th className="heder-print">ลำดับ</th>
                      <th className="heder-print">นัดลูกค้า</th>
                      <th className="heder-print">Code Sub</th>
                      <th className="heder-print">Code Sales</th>
                      <th className="heder-print">Name Sales</th>
                      <th className="heder-print">ประเภท</th>
                      <th className="heder-print">No.ใบสั่ง</th>
                      <th className="heder-print">ชื่อ-สกุลลูกค้า</th>
                      {/* <th className="heder-print">Security Code</th> */}
                      <th className="heder-print">พื้นที่ที่สั่งงาน</th>
                      <th className="heder-print">Zone</th>
                      <th className="heder-print">หมายเหตุ</th>
                      <th className="heder-print">ผลการวิ่งงาน</th>
                  </thead>
                  <tbody className="pagebreak">
                  {item.document_data.map((item2)=>{
                    return (
                      <>
                        <tr>
                          <td className="body-print">{item2.list_no}</td>
                          <td className="body-print">{item2.docudate}</td>
                          <td className="body-print">{item2.sup_code}</td>
                          <td className="body-print">{item2.emp_code}</td>
                          <td className="body-print">{item2.sale_name}</td>
                          <td className="body-print">{item2.job_type_name}</td>
                          <td className="body-print">{item2.listno_order}</td>
                          <td className="body-print">{item2.customer_name}</td>
                          {/* <td className="body-print">{item2.security_code}</td> */}
                          <td className="body-print">{item2.order_area_name}</td>
                          <td className="body-print">{item2.zone_master_name}</td>
                          <td className="body-print">{item2.remark}</td>                      
                          <td className="body-print">{item2.status_document_master_name}</td>
                      </tr>
                      {/* <div className="pagebreak"></div> */}
                      </>
                    )
                  })}
                  </tbody>
              </table>
              {/* <div className="pagebreak"></div> */}
              {/* {item.document_data.length >= 10 ? <div className="pagebreak"></div> : <></>} */}
            </div>
            : <div></div>
            })}
          </div>
        </div>
      </>
    );
  }

  function datePicker() {
    return (
      <>
        <DateRange
          onClick={(date) => {
            setStartDate(date[0].startDate);
            setEndDate(date[0].endDate);
            getData(page, pageSize, date[0].startDate, date[0].endDate, search);
          }}
        />
      </>
    );
  }

  return (
    <>
      {/* <label>บันทึกรายละเอียดงานประจำวัน</label> */}
      <Card
        variant="outlined"
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          borderRadius: "10px",
        }}
      >
        {HeaderPage()}
        {tableExport()}
        <DataTablePaginationServer
          tableRef={tableRef}
          exportButton={true}
          columns={columns}
          data={documentData}
          page={page}
          totalCount={countRowData}
          width="100%"
          onChangePage={(event, newPage) => {
            setPage(newPage);
            getData(newPage, pageSize, startDate, endDate, search);
          }}
          onChangeRowsPerPage={(e) => {
            setPageSize(e.target.value);
            getData(page, e.target.value, startDate, endDate, search);
          }}
          pageSize={pageSize}
        />
      </Card>
      {openDialogformEdit && (
        <AddDailyJobDetailsRecordNotSuccess
          onCancel={() => setOpenDialogFormEdit(false)}
          open={openDialogformEdit}
          documentId={documentId}
        />
      )}
      {openDialogformAdd && (
        <AddDailyJobDetailsRecordNotSuccess
          onCancel={() => setOpenDialogFormAdd(false)}
          open={openDialogformAdd}
          documentId={null}
        />
      )}
      <Loading open={loading} />
    </>
  );
}

export default DailyJobDetailsRecordNotSuccess;
